import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import PuzzlesPage from './pages/PuzzlesPage';
import PuzzlePage from './pages/PuzzlePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import GamesPage from './pages/GamesPage';
import LobbyPage from './pages/LobbyPage';
import GuessWhatGame from './pages/GuessWhatGame';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<PuzzlesPage />} />
        <Route path="/puzzles" element={<PuzzlesPage />} />
        <Route path="/puzzles/:slug" element={<PuzzlePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/games" element={<GamesPage />} />
        <Route path="/games/lobby/:lobbyId" element={<LobbyPage />} />
        <Route path="/games/guesswhat/:gameId" element={<GuessWhatGame />} />
      </Routes>
    </Layout>
  );
}

export default App;
